import { utilities } from 'core/use-cases';

/**
 * Returns the async actions (success | failure) from the given action request type.
 *
 */
export function getAsyncActions<T extends string>(type: T) {
  if (!type.endsWith(utilities.REQUEST_STATE.REQUEST)) {
    throw new Error(`${type} is not a valid request action type.`);
  }

  const actionPrefix = type.replace(utilities.REQUEST_STATE.REQUEST, '');

  return {
    success: `${actionPrefix}${utilities.REQUEST_STATE.SUCCESS}`,
    failure: `${actionPrefix}${utilities.REQUEST_STATE.FAILURE}`,
  };
}
